<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div *ngIf="this.label != null" class="row">
    <div class="col-md-9">
        <div class="form-label">{{this.label}}</div>
    </div>
  </div>
  <div class="row">
    <div class="col">
        <input 
          id="{{this.propertyId}}" 
          class="form-control mr-2"
          [ngClass]="[this.isInvalid() ? 'is-invalid' : '',  regular ? '' : 'input-box']"
          type="text" 
          maxlength={{this.maxLength}} 
          formControlName="{{this.propertyName}}"
          (keydown.space)="$event.preventDefault()"
          (input)="formatPostalCode($event)"
          value={{this.postalCode}}>
    </div>
  </div>
  <app-validator-message [formGroup]="this.formGroup" propertyName="{{this.propertyName}}"></app-validator-message>
</div>